import { YANDEX_METRIKA_ID } from '../env';

export const initializeYm = () => {
  if (!YANDEX_METRIKA_ID) {
    return;
  }

  const yandexMetrikaCode = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
     m[i].l=1*new Date();
     for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
     k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
     (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

     ym(${YANDEX_METRIKA_ID}, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true
     });`;

  const script = document.createElement('script');

  script.innerHTML = yandexMetrikaCode;
  script.type = 'text/javascript';
  document.head.appendChild(script);
};
